// ── My Workbench backgrounds (2 Oct, on trial) ─────────────────────────────────
//
// Light mode only. Each person picks their own; it is saved to their login
// (users.workbench_bg, /api/workbench/background), so it follows them to any
// stand. The ids must match BACKGROUNDS in server/helpers/workbench.js.
//
// On any background the toolbar, the stat tiles and the column headings sit
// on frosted glass so small text stays readable; the cards sit straight on
// the picture, which is where the contrast comes from. tone says whether the
// picture is light or dark, for anything that needs to know later.
// tint is laid over a photo so its brightest patches never compete with the
// cards. The photos are The Loose Wheel's own (Manny, 2 Oct), compressed to
// 2560px wide WebP, and only downloaded by someone who picks them.

const P = process.env.PUBLIC_URL || '';

export const WORKBENCH_BACKGROUNDS = [
  { id: 'plain', name: 'Plain', tone: 'light' },
  { id: 'topographic', name: 'Topographic', tone: 'light', thumb: `${P}/backgrounds/topographic.svg`,
    layer: { backgroundColor: '#e6ece1', backgroundImage: `url(${P}/backgrounds/topographic.svg)`, backgroundSize: 'cover', backgroundPosition: 'center' } },
  { id: 'pegboard', name: 'Pegboard', tone: 'light', thumb: `${P}/backgrounds/pegboard.svg`, thumbSize: '28px 28px',
    layer: { backgroundColor: '#ebe2d2', backgroundImage: `url(${P}/backgrounds/pegboard.svg)`, backgroundSize: '28px 28px' } },
  { id: 'toolwall', name: 'Tool wall', tone: 'dark', thumb: `${P}/backgrounds/toolwall-thumb.webp`,
    layer: { backgroundColor: '#3b2b1d', backgroundImage: `linear-gradient(180deg, rgba(12,18,30,0.28), rgba(12,18,30,0.50)), url(${P}/backgrounds/toolwall.webp)`,
      backgroundSize: 'cover', backgroundPosition: 'center' } },
  { id: 'trail-ride', name: 'Trail ride', tone: 'dark', thumb: `${P}/backgrounds/trail-ride-thumb.webp`,
    layer: { backgroundColor: '#1f3a1c', backgroundImage: `linear-gradient(180deg, rgba(8,20,12,0.30), rgba(8,20,12,0.48)), url(${P}/backgrounds/trail-ride.webp)`,
      backgroundSize: 'cover', backgroundPosition: 'center' } },
];

export const backgroundById = (id) => WORKBENCH_BACKGROUNDS.find(b => b.id === id) || WORKBENCH_BACKGROUNDS[0];

// Frosted glass for what sits directly on a dark picture. No backdrop-filter:
// it would make the glass the containing block for position:fixed children,
// and the "timer still running" dialog lives inside it.
export const GLASS = {
  background: 'rgba(240,240,235,0.90)',
  border: '1px solid rgba(255,255,255,0.6)',
  borderRadius: 14,
  boxShadow: '0 6px 20px rgba(0,0,0,0.25)',
};
